import React, { useState } from "react";
import { useAuth } from "../../authProvider";
import { updateImage } from "../../../services/params";
import { showSuccessToaster } from "../../../Utils/toasters/success";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUserProfileImageURL } from "../../../Utils";
import { useTranslation } from "react-i18next";
function ProfileImageForm() {
  const { currentUser, updateCurrentUser } = useAuth();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const [profileImage, setProfileImage] = useState(currentUser?.image);
  const { t } = useTranslation();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileImage(e.target.result);
      };
      reader.readAsDataURL(file);
      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    setLoading(true);
    setErrors({ hasError: false, msg: "" });

    if (!selectedFile) {
      setErrors({
        hasError: true,
        msg: t("selectImage"),
      });
      setLoading(false);
      return;
    }

    const res = await updateImage(currentUser?.userId, selectedFile);

    if (!res.success) {
      setErrors({
        hasError: true,
        msg: res.msg,
      });
      setLoading(false);
      return;
    }

    updateCurrentUser({ image: getUserProfileImageURL(currentUser?.userId) });
    showSuccessToaster("Succès!!");
    setLoading(false);
  };

  return (
    <>
      <div className="image-input-group">
        <img className="profile-image" src={profileImage} alt="profile" />
        <label htmlFor="imageInput" className="edit-image-icon">
          <FontAwesomeIcon icon={faPen} />
        </label>
        <input
          type="file"
          id="imageInput"
          name="image"
          style={{ display: "none" }}
          onChange={handleImageChange}
        />
      </div>

      <div className="error-msg d-flex justify-content-center">
        {errors.hasError ? <p>{errors.msg}</p> : <div></div>}
      </div>

      {/* <button
        className="tab-btn-submit"
        onClick={handleUpload}
        disabled={loading}
      >
        {t("update")}
      </button> */}
    </>
  );
}

export default ProfileImageForm;
